import { FC, useCallback, useEffect, useMemo } from 'react';
import {
  VsAssociateEventType,
  chatActions,
  useGetAssociateEvents,
  useGetActiveHeroConversations,
  useGetArchivedHeroConversations,
  HeroConversation,
} from '@vs-online-only-app/state';
import EndedConversationBanner from './ended-conversation/EndedConversationBannner';
import { useSelectedHeroConversation } from '../hooks/useSelectedHeroConversation';
import { useDispatch } from 'react-redux';

const EndedConversations: FC = () => {
  const dispatch = useDispatch();
  const selectedConversation = useSelectedHeroConversation();
  const getActiveHeroConversationsQuery = useGetActiveHeroConversations();
  const useGetArchivedHeroConversationsQuery =
    useGetArchivedHeroConversations();
  const { data: associateEvents } = useGetAssociateEvents();

  const refreshConversations = useCallback(() => {
    getActiveHeroConversationsQuery.refetch();
    useGetArchivedHeroConversationsQuery.refetch();
  }, [getActiveHeroConversationsQuery, useGetArchivedHeroConversationsQuery]);

  const lastEndedConversationEvent = useMemo(
    () =>
      associateEvents?.filter((e) => {
        return (
          !e.read &&
          (e.type === VsAssociateEventType.ConversationAutoEnded ||
            e.type === VsAssociateEventType.ConversationEnded)
        );
      })?.[0],
    [associateEvents],
  );

  useEffect(() => {
    const onConversationEnded = (endedConversation: HeroConversation) => {
      refreshConversations();
      if (
        selectedConversation &&
        selectedConversation.id === endedConversation.id
      ) {
        dispatch(chatActions.setSelectedConversation(undefined));
      }
    };
    if (lastEndedConversationEvent) {
      onConversationEnded(lastEndedConversationEvent.conversation);
    }
  }, [lastEndedConversationEvent]);

  if (!lastEndedConversationEvent) {
    return null;
  }

  const autoEnded =
    lastEndedConversationEvent?.type ===
    VsAssociateEventType.ConversationAutoEnded;

  return (
    <EndedConversationBanner
      endedConversationEvent={lastEndedConversationEvent}
      autoEnded={autoEnded}
    />
  );
};

export default EndedConversations;
